// extracted by mini-css-extract-plugin
export var mobile = "PopularSearches-module--mobile--7d27b";
export var tag = "PopularSearches-module--tag--cda48";
export var tagsRow = "PopularSearches-module--tagsRow--3ab92";
export var title = "PopularSearches-module--title--a15b6";
export var wrapper = "PopularSearches-module--wrapper--d078b";